import { useCallback, useEffect, useState } from 'react';
import { useControlledValue } from '../../hooks/useControlledValue';
import { arrayContainsItem, executeFilterableItemsEqual, maybeAddCreatedItemToArrays, maybeDeleteCreatedItemFromArrays, } from './FilterableListBaseUtils';
export const useSingleFilterableListBase = (props) => {
    const { selectedItem: selectedItemProp, defaultItem, itemsEqual, itemRenderer: itemRendererProp, onItemChange, items, itemEmpty, } = props;
    const [createdItems, setCreatedItems] = useState([]);
    const [selectedItem, setSelectedItem] = useControlledValue({
        controlled: selectedItemProp,
        default: defaultItem,
        name: 'useSingleFilterableListBase',
    });
    const itemRenderer = (item, itemProps) => {
        const selected = executeFilterableItemsEqual(itemsEqual, item, selectedItem);
        return itemRendererProp(item, {
            ...itemProps,
            modifiers: {
                ...itemProps.modifiers,
                selected,
            },
        });
    };
    const handleItemSelect = (newSelectedItem) => {
        setSelectedItem(newSelectedItem);
        onItemChange?.(newSelectedItem);
        // Delete the old item from the list if it was newly created.
        const step1Result = maybeDeleteCreatedItemFromArrays(itemsEqual, items, createdItems, selectedItem);
        // Add the new item to the list if it is newly created.
        const step2Result = maybeAddCreatedItemToArrays(itemsEqual, step1Result.items, step1Result.createdItems, newSelectedItem);
        setCreatedItems(step2Result.createdItems);
        const createdIndex = step2Result.createdItems.indexOf(newSelectedItem);
        const selectedIndex = createdIndex >= 0
            ? step2Result.items.length - 1 + createdIndex
            : undefined;
        return selectedIndex;
    };
    const handleClear = useCallback((afterItemsRemove, event) => {
        event?.stopPropagation();
        if (selectedItem && !itemEmpty?.(selectedItem)) {
            afterItemsRemove?.([selectedItem], event);
            const emptyItem = itemEmpty ? items.find(itemEmpty) : undefined;
            onItemChange?.(emptyItem);
            setSelectedItem(emptyItem);
        }
    }, [selectedItem, itemEmpty, setSelectedItem, onItemChange, items]);
    useEffect(() => {
        if (selectedItem &&
            !itemEmpty?.(selectedItem) &&
            !arrayContainsItem(itemsEqual, items, selectedItem)) {
            handleClear();
        }
    }, [itemEmpty, items, itemsEqual, selectedItem, handleClear]);
    return {
        itemRenderer,
        handleItemSelect,
        handleClear,
        items: [...items, ...createdItems],
        selectedItem,
    };
};
